<script setup>
import {
    ref,
} from 'vue';
import AppIcon from '../../atoms/app/AppIcon';
import SvgNorika from '../../atoms/svg/SvgNorika';
import SvgFacebook from '../../atoms/svg/social-icons/SvgFacebook';
import SvgInstagram from '../../atoms/svg/social-icons/SvgInstagram';
import SvgLinkedin from '../../atoms/svg/social-icons/SvgLinkedin';
import SvgPinterest from '../../atoms/svg/social-icons/SvgPinterest';
import SvgTiktok from '../../atoms/svg/social-icons/SvgTiktok';
import SvgYoutube from '../../atoms/svg/social-icons/SvgYoutube';

defineProps({
    variant: {
        type: String,
        default: 'full',
    },
    transparent: {
        type: Boolean,
        default: false,
    },
});

const activeHeader = ref(null);

function toggleActiveHeader(index) {
    activeHeader.value = activeHeader.value === index ? null : index;
}
</script>

<template>
    <div
        :class="{
            [`c-appFooter--${variant}`]: variant,
            [`c-appFooter--transparent`]: transparent
        }"
        class="c-appFooter"
    >
        <div class="c-appFooter__wrap">
            <div
                v-if="variant === 'full'"
                class="c-appFooter__row"
            >
                <div
                    :class="{ 'is-open': activeHeader === 0 }"
                    class="c-appFooter__container"
                    data-qa="container"
                >
                    <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events -->
                    <h3
                        class="c-appFooter__group-header"
                        data-qa="group header"
                        @click="toggleActiveHeader(0)"
                    >
                        Über karriere.at
                        <div class="c-appFooter__group-header-icon">
                            <AppIcon
                                name="arrow-down"
                                size="s"
                            />
                        </div>
                    </h3>
                    <ul class="c-appFooter__list c-appFooter__list--no-border">
                        <li class="c-appFooter__item">
                            <a
                                title="Über karriere.at"
                                class="c-appFooter__link"
                                href="/ueber-uns"
                            >
                                Über uns
                            </a>
                        </li>
                        <li class="c-appFooter__item">
                            <a
                                title="Jobs bei karriere.at"
                                class="c-appFooter__link"
                                href="/ueber-uns/jobs-bei-karriere-at"
                            >
                                Jobs bei karriere.at
                            </a>
                        </li>
                        <li class="c-appFooter__item">
                            <a
                                title="Presse"
                                class="c-appFooter__link"
                                href="/presse"
                            >
                                Presse
                            </a>
                        </li>
                    </ul>
                    <ul class="c-appFooter__list">
                        <li class="c-appFooter__item">
                            <a
                                title="Mobile App"
                                class="c-appFooter__link"
                                href="/mobileapp"
                            >
                                Mobile App
                            </a>
                        </li>
                        <li class="c-appFooter__item">
                            <a
                                title="Blog & Tipps"
                                class="c-appFooter__link"
                                href="https://www.karriere.at/blog/"
                            >
                                Blog &amp; Tipps
                            </a>
                        </li>
                    </ul>
                </div>

                <div
                    :class="{ 'is-open': activeHeader === 1 }"
                    class="c-appFooter__container"
                >
                    <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events -->
                    <h3
                        class="c-appFooter__group-header"
                        @click="toggleActiveHeader(1)"
                    >
                        Für Arbeitgeber
                        <div class="c-appFooter__group-header-icon">
                            <AppIcon
                                name="arrow-down"
                                size="s"
                            />
                        </div>
                    </h3>
                    <ul class="c-appFooter__list">
                        <li class="c-appFooter__item">
                            <a
                                title="Produkte &amp; Preise"
                                class="c-appFooter__link"
                                href="https://business.karriere.at/"
                            >
                                Produkte &amp; Preise
                            </a>
                        </li>
                        <li class="c-appFooter__item">
                            <a
                                title="Inserat schalten"
                                class="c-appFooter__link"
                                href="https://business.karriere.at/produkte/stelleninserate"
                            >
                                Inserat schalten
                            </a>
                        </li>
                        <li class="c-appFooter__item">
                            <a
                                title="Talentsuche"
                                class="c-appFooter__link"
                                href="https://business.karriere.at/produkte/talentsuche"
                            >
                                Talentsuche
                            </a>
                        </li>
                        <li class="c-appFooter__item">
                            <a
                                title="Employer Branding"
                                class="c-appFooter__link"
                                href="https://business.karriere.at/produkte/arbeitgeberprofil"
                            >
                                Employer Branding
                            </a>
                        </li>
                    </ul>
                </div>

                <div
                    :class="{ 'is-open': activeHeader === 2 }"
                    class="c-appFooter__container"
                >
                    <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events -->
                    <h3
                        class="c-appFooter__group-header"
                        @click="toggleActiveHeader(2)"
                    >
                        Partner und Portale
                        <div class="c-appFooter__group-header-icon">
                            <AppIcon
                                name="arrow-down"
                                size="s"
                            />
                        </div>
                    </h3>
                    <ul class="c-appFooter__list">
                        <li class="c-appFooter__item">
                            <a
                                title="jobradius.at"
                                class="c-appFooter__link"
                                href="https://jobradius.at/"
                                rel="noopener"
                            >
                                jobradius.at
                            </a>
                        </li>
                        <li class="c-appFooter__item">
                            <a
                                title="itstellen.at"
                                class="c-appFooter__link"
                                href="https://www.itstellen.at/"
                                rel="noopener"
                            >
                                itstellen.at
                            </a>
                        </li>
                        <li class="c-appFooter__item">
                            <a
                                title="techtalents.at"
                                class="c-appFooter__link"
                                href="https://www.techtalents.at/"
                                rel="noopener"
                            >
                                techtalents.at
                            </a>
                        </li>
                        <li class="c-appFooter__item">
                            <a
                                title="financejobs.at"
                                class="c-appFooter__link"
                                href="https://www.financejobs.at/"
                                rel="noopener"
                            >
                                financejobs.at
                            </a>
                        </li>
                        <li class="c-appFooter__item">
                            <a
                                title="salescareer.at"
                                class="c-appFooter__link"
                                href="https://www.salescareer.at/"
                                rel="noopener"
                            >
                                salescareer.at
                            </a>
                        </li>
                        <li class="c-appFooter__item">
                            <a
                                title="jobs.at"
                                class="c-appFooter__link"
                                href="https://www.jobs.at/"
                                rel="noopener"
                            >
                                jobs.at
                            </a>
                        </li>
                        <li class="c-appFooter__item">
                            <a
                                title="hokify"
                                class="c-appFooter__link"
                                href="https://hokify.at/"
                                rel="noopener"
                            >
                                hokify
                            </a>
                        </li>
                        <li class="c-appFooter__item">
                            <a
                                title="eRecruiter"
                                class="c-appFooter__link"
                                href="https://www.erecruiter.net/"
                                rel="noopener"
                            >
                                eRecruiter
                            </a>
                        </li>
                    </ul>
                </div>

                <div
                    :class="{ 'is-open': activeHeader === 3 }"
                    class="c-appFooter__container"
                >
                    <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events -->
                    <h3
                        class="c-appFooter__group-header"
                        @click="toggleActiveHeader(3)"
                    >
                        Mein Profil
                        <div class="c-appFooter__group-header-icon">
                            <AppIcon
                                name="arrow-down"
                                size="s"
                            />
                        </div>
                    </h3>
                    <ul class="c-appFooter__list">
                        <li class="c-appFooter__item">
                            <a
                                title="Lebenslauf"
                                class="c-appFooter__link"
                                href="/profil/lebenslauf"
                            >
                                Lebenslauf
                            </a>
                        </li>
                        <li class="c-appFooter__item">
                            <a
                                title="Job-Alarm"
                                class="c-appFooter__link"
                                href="/jobalarm"
                            >
                                Job-Alarm
                            </a>
                        </li>
                        <li class="c-appFooter__item">
                            <a
                                title="Merkliste"
                                class="c-appFooter__link"
                                href="/watchlist"
                            >
                                Merkliste
                            </a>
                        </li>
                        <li class="c-appFooter__item">
                            <a
                                title="Firmen-Alarm"
                                class="c-appFooter__link"
                                href="/companyalarm"
                            >
                                Firmen-Alarm
                            </a>
                        </li>
                        <li class="c-appFooter__item">
                            <a
                                title="Job-Empfehlungen"
                                class="c-appFooter__link"
                                href="/matching"
                            >
                                Job-Empfehlungen
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="c-appFooter__social-media-container">
                <ul class="c-appFooter__social-list">
                    <li class="c-appFooter__social-item">
                        <a
                            title="Instagram"
                            aria-label="zum Instagram Profil von karriere.at"
                            class="
                                c-appFooter__social-icon
                                c-appFooter__social-link
                                c-appFooter__social-link--instagram
                            "
                            href="https://www.instagram.com/karriere.at/"
                            target="_blank"
                            rel="noopener"
                        >
                            <SvgInstagram class="c-appIcon c-appIcon--xl"/>
                        </a>
                    </li>
                    <li class="c-appFooter__social-item">
                        <a
                            title="Linkedin"
                            aria-label="zum Linkedin Profil von karriere.at"
                            class="
                                c-appFooter__social-icon
                                c-appFooter__social-link
                                c-appFooter__social-link--linkedin
                            "
                            href="https://www.linkedin.com/company/karriere-at/"
                            target="_blank"
                            rel="noopener"
                        >
                            <SvgLinkedin class="c-appIcon c-appIcon--xl"/>
                        </a>
                    </li>
                    <li class="c-appFooter__social-item">
                        <a
                            title="Facebook"
                            aria-label="zum Facebook Profil von karriere.at"
                            class="
                                c-appFooter__social-icon
                                c-appFooter__social-link
                                c-appFooter__social-link--facebook
                            "
                            href="https://www.facebook.com/karriere.at"
                            target="_blank"
                            rel="noopener"
                        >
                            <SvgFacebook class="c-appIcon c-appIcon--xl"/>
                        </a>
                    </li>
                    <li class="c-appFooter__social-item">
                        <a
                            title="TikTok"
                            aria-label="zum TikTok Profil von karriere.at"
                            class="
                                c-appFooter__social-icon
                                c-appFooter__social-link
                                c-appFooter__social-link--tiktok
                            "
                            href="https://www.tiktok.com/@karriere.at"
                            target="_blank"
                            rel="noopener"
                        >
                            <SvgTiktok class="c-appIcon c-appIcon--xl"/>
                        </a>
                    </li>
                    <li class="c-appFooter__social-item">
                        <a
                            title="YouTube"
                            aria-label="zum YouTube Kanal von karriere.at"
                            class="
                                c-appFooter__social-icon
                                c-appFooter__social-link
                                c-appFooter__social-link--youtube
                            "
                            href="https://www.youtube.com/user/karriereatchannel"
                            target="_blank"
                            rel="noopener"
                        >
                            <SvgYoutube class="c-appIcon c-appIcon--xl"/>
                        </a>
                    </li>
                    <li class="c-appFooter__social-item">
                        <a
                            title="Pinterest"
                            aria-label="zum Pinterest Board von karriere.at"
                            class="
                                c-appFooter__social-icon
                                c-appFooter__social-link
                                c-appFooter__social-link--pinterest
                            "
                            href="https://www.pinterest.at/karriereat/"
                            target="_blank"
                            rel="noopener"
                        >
                            <SvgPinterest class="c-appIcon c-appIcon--xl"/>
                        </a>
                    </li>
                </ul>
            </div>

            <div class="c-appFooter__subline">
                <ul class="c-appFooter__subline-link-list">
                    <li class="c-appFooter__subline-item">
                        <a
                            title="Häufige Fragen"
                            class="c-appFooter__link"
                            href="/lp/faqs"
                        >
                            Häufige Fragen
                        </a>
                    </li>
                    <li class="c-appFooter__subline-item">
                        <a
                            title="Impressum &amp; Kontakt"
                            class="c-appFooter__link"
                            href="/impressum"
                        >
                            Impressum &amp; Kontakt
                        </a>
                    </li>
                    <li class="c-appFooter__subline-item">
                        <a
                            title="AGB"
                            class="c-appFooter__link"
                            href="/agb"
                        >
                            AGB
                        </a>
                    </li>
                    <li class="c-appFooter__subline-item">
                        <a
                            title="Datenschutz"
                            class="c-appFooter__link"
                            href="/datenschutzerklaerung"
                        >
                            Datenschutz
                        </a>
                    </li>
                    <li class="c-appFooter__subline-item">
                        <a
                            title="Code of Conduct"
                            class="c-appFooter__link"
                            href="/code-of-conduct"
                        >
                            Code of Conduct
                        </a>
                    </li>
                </ul>
                <ul class="c-appFooter__subline-par">
                    <li class="c-appFooter__subline-item">
                        &copy; {{ (new Date()).getFullYear() }}
                        <a
                            title="karriere.at"
                            class="c-appFooter__link c-appFooter__link--karriereat"
                            href="/"
                        >
                            karriere.at
                        </a>
                        GmbH
                    </li>
                    <li class="c-appFooter__subline-item">
                        <a
                            title="norika Group"
                            aria-label="zur norika Group"
                            class="c-appFooter__linkNorika"
                            href="https://norika.com"
                            target="_blank"
                            rel="noopener"
                        >
                            <SvgNorika/>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
@use 'sass:math';

@import '~@karriereat/global-styles/scss/tools/typo';
@import '~@karriereat/global-styles/scss/components/link/mixins';
@import '../../../assets/scss/settings/breakpoint';
@import '../../../assets/scss/settings/size';
@import '../../../assets/scss/settings/font-size';
@import '../../../assets/scss/tools/wrap';

// TODO: Refactoring needed, nesting and descending
// specificity should not be necessary.
// stylelint-disable max-nesting-depth, no-descending-specificity
.c-appFooter {
    $root: &;

    background: var(--k-white);

    @media (min-width: $k-breakpoint--m) {
        padding-top: $k-spacing--xl;
        padding-bottom: $k-spacing--xl;
    }

    @media print {
        display: none;
    }

    &--full {
        @media (min-width: $k-breakpoint--m) {
            padding-top: $k-spacing--3xl;
            padding-bottom: $k-spacing--2xl;
        }
    }

    &--minimal {
        #{$root}__subline {
            flex-direction: column;
            text-align: center;
        }

        #{$root}__subline-item {
            &:last-child {
                margin-right: 0;
            }
        }

        #{$root}__subline-link-list,
        #{$root}__subline-par {
            display: block;
        }

        #{$root}__subline-par {
            margin-top: $k-spacing--s;
        }

        #{$root}__social-media-container {
            @media (min-width: $k-breakpoint--l) {
                text-align: center;
            }
        }
    }

    &--transparent {
        background: transparent;
    }

    &--center {
        text-align: center;
    }

    &__wrap {
        @media (min-width: $k-breakpoint--m) {
            @include wrap;

            max-width: $k-size-wrap-max-width;
        }
    }

    &__item {
        padding: $k-spacing--xs $k-spacing--l;

        @media (min-width: $k-breakpoint--m) {
            margin-bottom: $k-spacing--s;
            padding: 0;
        }
    }

    &__row {
        display: flex;
        flex-wrap: wrap;
    }

    &__container {
        width: 100%;

        @media (min-width: $k-breakpoint--m) {
            width: 25%;
        }

        &.is-open {
            .c-appFooter__list {
                display: block;
                padding-bottom: $k-spacing--l;

                &--no-border {
                    padding-bottom: 0;
                    border-bottom: 0;
                }

                @media (min-width: $k-breakpoint--m) {
                    padding-bottom: 0;
                    border-bottom: 0;
                }
            }

            .c-appFooter__group-header-icon {
                transform: rotate(180deg);
            }
        }
    }

    &__group-header {
        position: relative;
        padding: $k-spacing--m $k-spacing--l;
        font-weight: bold;
        cursor: pointer;

        @media (min-width: $k-breakpoint--m) {
            margin-bottom: $k-spacing--l;
            padding: 0;
            border-bottom: 0;
            cursor: default;
        }
    }

    &__group-header-icon {
        position: absolute;
        top: 50%;
        right: $k-spacing--xl;
        margin-top: - math.div($k-spacing--xl, 2);

        @media (min-width: $k-breakpoint--m) {
            display: none;
        }
    }

    &__list {
        display: none;
        list-style-type: none;

        @media (min-width: $k-breakpoint--m) {
            display: block;
            margin-bottom: $k-spacing--l;
        }
    }

    &__link {
        text-decoration: underline;
        @include k-c-link(var(--k-gray-900), var(--k-gray-600), var(--k-gray-900));

        &--karriereat {
            margin: 0 $k-spacing--xs;
            text-decoration: none;
        }
    }

    &__linkNorika {
        color: var(--k-gray-900);
        transition: color 0.2s;

        &:hover {
            color: var(--k-gray-600);
        }
    }

    &__social-media-item {
        display: inline-block;
        margin-right: $k-spacing--m;
    }

    &__icon {
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        margin: 0 auto;
        width: 42px;
        height: 42px;
        border-radius: 42px;
        background: var(--k-white);
    }

    &__subline {
        padding-top: $k-spacing--xl;
        padding-right: $k-spacing--l;
        padding-left: $k-spacing--l;
        text-align: center;

        @media (min-width: $k-breakpoint--m) {
            padding-right: 0;
            padding-left: 0;
            text-align: left;
        }

        @media (min-width: $k-breakpoint--l) {
            display: flex;
            padding-top: 0;
            text-align: left;
        }
    }

    &__subline-par {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: $k-spacing--2xl;

        @media (min-width: $k-breakpoint--m) {
            align-items: start;
        }

        @media (min-width: $k-breakpoint--l) {
            display: inline-flex;
            flex-grow: 1;
            flex-direction: row;
            justify-content: space-between;
            margin-right: $k-spacing--m;
            padding-bottom: 0;
            width: auto;
        }
    }

    &__subline-link-list {
        margin-bottom: $k-spacing--s;

        @media (min-width: $k-breakpoint--l) {
            display: inline-block;
            margin-bottom: 0;
        }
    }

    &__subline-item {
        display: inline-flex;
        margin-right: $k-spacing--m;

        @media (min-width: $k-breakpoint--l) {
            margin-right: $k-spacing--l;
        }
    }

    &__social-media-container {
        margin-bottom: -$k-spacing--s;
        padding-top: $k-spacing--2xl;
        padding-bottom: 0;
        text-align: center;

        @media (min-width: $k-breakpoint--m) {
            margin-bottom: $k-spacing--l;
            text-align: left;
        }
    }

    &__social-list {
        display: inline-block;
    }

    &__social-item {
        display: inline-block;
        margin-right: $k-spacing--m;
    }

    &__social-link {
        @include k-c-link(var(--k-gray-900), var(--k-gray-900), var(--k-gray-900));

        &--instagram {
            &:hover {
                color: var(--k-social-instagram);
            }
        }

        &--linkedin {
            &:hover {
                color: var(--k-social-linkedin);
            }
        }

        &--facebook {
            &:hover {
                color: var(--k-social-facebook);
            }
        }

        &--tiktok {
            &:hover {
                color: var(--k-social-tiktok);
            }
        }

        &--youtube {
            &:hover {
                color: var(--k-social-youtube);
            }
        }

        &--pinterest {
            &:hover {
                color: var(--k-social-pinterest);
            }
        }
    }
}
// stylelint-enable
</style>
